module.exports = __webpack_public_path__ + "img/V-63-ST-1200-BB.3f43b5aa.png";